import React, { useContext, useState, useEffect } from "react";
import AppContext from '../../../store/AppContext';
import { useIdleTimer } from "react-idle-timer";
import { isExpired, decodeToken } from "react-jwt";
import * as FileSaver from 'file-saver';
import XLSX from "sheetjs-style";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import { FaRegListAlt } from "react-icons/fa";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import CustomTooltip from "../../Shared/CustomTooltip";

function Header_Coral(props) {
  let activeClassName = "nav-link active";
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [buttonClass, setButtonClass] = useState(props.clsname.intial.button);
  const [buttonClassMobile, setButtonClassMobile] = useState(props.clsMobile.intial.button);
  const [excelData, setexcelData] = useState([]);
  const navigate = useNavigate()

  const user = sessionStorage.getItem("user");
  const sessionToken = user ? JSON.parse(user) : null;
  // const sessionToken = JSON.parse(sessionStorage.user)
  let myDecodedSessionToken = decodeToken(sessionToken?.token)

  // code for excel
  // const excelData = [
  //   {
  //     "first_name": "sanku",
  //     "last_name": "mangure"
  //   },
  //   {
  //     "first_name": "aditi",
  //     "last_name": "salokhe"
  //   }
  // ]
  const log_data = (data) => {
    // console.log(data);
    setexcelData(data.data)
  }

  const [hasExcelAccess, setHasExcelAccess] = useState(false)

  useEffect(() => {
    setexcelData(excelData)
    fetchData({ url: API_URL_MAIN + "auth/usage_logs", }, log_data)
    fetchData({ url: API_URL_MAIN + "auth/all_users_count" }, data_count);

    const token = JSON.parse(sessionStorage.user);
    let myDecodedToken = decodeToken(token.token);
    let username = myDecodedToken.username;
    // let username = "sm925413.ttl"
    if (username === "sm925413.ttl" || username === "bipins.ttl" || username === "snehaj1.ttl" || username === "nv.ttl" || username === "sn927776.ttl") {
      setHasExcelAccess(true)
    }
  }, [hasExcelAccess]);

  const excelFileName = "cvec user logs";
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, excelFileName + fileExtension);
  }
  // code for excel

  const app_ctx = useContext(AppContext);
  const logout = () => {
    navigate('/')
    app_ctx.logout_user();
  }

  const get_token = () => {
    let token = ''
    if (
      sessionStorage.getItem('user') != '' &&
      sessionStorage.getItem('user') != null
    ) {
      token = JSON.parse(sessionStorage.user).token
      // console.log(token);
    }
    return token
  }

  const redirectUser = async () => {
    // app_ctx.redirectUserToVehicleList()
    let token = get_token()
    try {
      const response = await axios.post(
        API_URL_MAIN + 'auth/logout',
        {
          log: 'logout',
          ev_bus: myDecodedSessionToken?.ev_bus
        },
        {
          headers: {
            'x-auth-token': token,
            'Content-Type': 'application/json'
          }
        }
      )
      if (response?.status === 200 || response?.status === 201) {
        navigate('/')
      }
    } catch (error) {
      console.log('Error in axios: ', axios)
    }
  }

  const handleOnIdle = event => { app_ctx.logout_user(); }
  useIdleTimer({ timeout: 300000, onIdle: handleOnIdle, debounce: 500 })
  // window.onunload = function () {
  //   app_ctx.logout_user();
  // }


  // const interval = setInterval(function () {
  //   navigator.onLine ? console.log("") : app_ctx.logout_user();
  // }, 5000);
  const [Departments, setDepartments] = useState([])
  const [UserCountTableData, setUserCountTableData] = useState([])
  const data_count = (data) => {
    setDepartments(['engineering', 'smart_city', 'quality', 'internal'])
    setUserCountTableData(data.data)
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="app-header bg-theme">
        <div className="app-header__logo">
          <div className="logo-src">
            <Link to="/homepage" className="d-flex align-items-center col-md-3 mb-2 mb-md-0 text-dark text-decoration-none">
              <img src={process.env.PUBLIC_URL + "assets/images/tml_wt.png"} />
            </Link>
          </div>
          <div className="header__pane ml-auto">
            <div>
              <button type="button" onClick={props.buttonClicked} className={buttonClass} data-class="closed-sidebar">
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="app-header__mobile-menu">
          <div>
            <button type="button" onClick={props.buttonClickedMobile} className={buttonClassMobile}>
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </div>
        <Link to="/homepage" className="mobLogo text-decoration-none ">
          <img src={process.env.PUBLIC_URL + "assets/images/tml_wt.png"} alt="logo" />
        </Link>
        <span className="headFont">Fleet Ascent EV</span>
        <div className="app-header__content">
          <div className="d-flex align-items-center ms-auto">
            {/* {
              loggedInUser.flagForHideShow === "ERC" &&
              <span className="material-icons colWhite mr-2" data-tag="criticalFaultyCycle" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ cursor: 'pointer' }}>assistant_direction</span>
            } */}
            <div className="mr-3 cursor-pointer">
              <a
                className={({ isActive }) => (isActive ? activeClassName : 'nav-link')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  gap: '5px'
                }}
                onClick={redirectUser}
              >
                <CustomTooltip text="Back to vehicle list" placement="bottom">
                  <FaRegListAlt style={{ color: '#83a4cf', fontSize: '16px' }} />
                </CustomTooltip>
                {/* <span style={{ fontSize: '13px', color: 'black' }}>
                                      <b>Project List 876543</b>
                                    </span> */}
              </a>
            </div>
            <div ><img src={process.env.PUBLIC_URL + "assets/images/sparqplug_logo.png"} width={45} height={45} /></div>
            {/* code for excel */}
            {hasExcelAccess &&
              <div className="dropdown me-1 ms-3">
                <span className="material-icons dropdown-toggle colWhite" data-bs-toggle="dropdown" data-bs-offset="10,5">
                  <svg className="mb-2" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="white" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.8 18H14l-2-3.4l-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4l2-3.4h1.8l-2.9 4.5l2.9 4.5M13 9V3.5L18.5 9H13Z" /></svg>
                </span>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <span className="dropdown-item d-flex align-items-center" href="javascript:void(0);" onClick={exportToExcel}>
                      <span className="material-icons">
                        info_outline
                      </span>
                      <span className="ms-2">Usage Log</span>
                    </span>
                  </li>
                </ul>
              </div>
            }
            {/* code for excel */}

            <div className="dropdown me-1 ms-2">
              <span className="material-icons dropdown-toggle colWhite" data-bs-toggle="dropdown" data-bs-offset="10,5">person</span>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item d-flex align-items-center" href="javascript:void(0);" onClick={logout}>
                    <span className="material-icons">logout</span>
                    <span className="ms-2">Logout </span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item d-flex align-items-center" href="#">
                    <span className="material-icons">
                      info_outline
                    </span>
                    <span className="ms-2">Support </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">User Details</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <table className="table table-striped" style={{ width: "100%" }}>
                <thead style={{ backgroundColor: "rgb(50, 135, 156)", color: "white" }}>
                  <tr>
                    <th scope="col">Department</th>
                    <th scope="col">CESL</th>
                    <th scope="col">ACE</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Departments.map((dept) => {
                      let tot = 0;
                      return (<tr key={dept}>
                        <td>{dept}</td>
                        {
                          UserCountTableData.map((item) => {
                            tot = Number(tot) + Number(item[dept])
                            return (<td key={item[dept]}>{item[dept]}</td>)
                          })
                        }
                        <td>{tot}</td>
                      </tr>)
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </>
  );



}

export default Header_Coral;
